import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { useGetOwnOrganizations } from '@/features/api/hooks/grapevine-organization/useGetOwnOrganizations';
import { ListSection } from '@/features/list/components/ListSection';
import { OrganizationCommentPushSettingItem } from '@/features/profile-setting/components/OrganizationCommentPushSettingItem';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { hasItems } from '@/shared/utils/array';

const organizationCommentPushSettingsStyles = StyleSheet.create({
  titleContainer: {
    justifyContent: 'space-between',
    flexDirection: 'row',
    marginHorizontal: 12
  },
  title: { marginBottom: 20, marginTop: 32 }
});

export const OrganizationCommentPushSettings: FC = () => {
  const { data: organizations } = useGetOwnOrganizations({
    directMembersOnly: true
  });
  const { t } = useTranslation(LocalizationNameSpace.PROFILE_SETTING, {
    keyPrefix: 'screens.notification-setting'
  });

  if (!hasItems(organizations)) {
    return;
  }

  return (
    <>
      <View style={organizationCommentPushSettingsStyles.titleContainer}>
        <Text
          style={organizationCommentPushSettingsStyles.title}
          variant="titleLarge"
        >
          {t('organizations')}
        </Text>
      </View>
      <ListSection
        title={t('commentPushNotifications')}
        style={{ backgroundColor: 'transparent' }}
        headerBackgroundColor="transparent"
      >
        {organizations.map((organization) => (
          <OrganizationCommentPushSettingItem
            key={organization.id}
            organization={organization}
          />
        ))}
      </ListSection>
    </>
  );
};
